import axios from "axios";

export function getAllUserActivity(page: number, size: number, type: string) {
  return axios.get(`/audit${type}?page=${page}&size=${size}`);
}

export function getUserSpecificActivity(
  page: number,
  size: number,
  entityId: string,
  entityType: string,
  fipId?: string
) {
  let url: string;
  fipId
    ? (url = `/audit/account/single?page=${page}&size=${size}&entityId=${entityId}&entityType=${entityType}&fipId=${fipId}`)
    : (url = `/audit/consent/single?page=${page}&size=${size}&entityId=${entityId}&entityType=${entityType}`);

  return axios.get(url);
}
